

export const accessData = {
  namespaced: true,
  state: {
    alias: "",
    phone: "",
    email: "",
    languageCode: "ES",
    principalUser: true,
    password: "",
  },
  getters: {},
  mutations: {
    changeAlias(state, payload) {
      state.alias = payload
    },
    changePhone(state, payload) {
      state.phone = payload
    },
    changeEmail(state, payload) {
      state.email = payload
    },
    changePassword(state, payload) {
      state.password = payload
    }
  },
  actions: {},
}